module.exports = __webpack_public_path__ + "img/Brille.21a0729d.jpg";